<script setup>
  import { shallowRef, defineAsyncComponent, onMounted } from "vue";
  import { storeToRefs } from "pinia";
  import { pascalCase } from "change-case";
  import { useGeneralSetupStore } from "@stores/survey/setup/generalSetup";

  const components = shallowRef({});
  const generalSetupStore = useGeneralSetupStore();
  const { currentFields } = storeToRefs(generalSetupStore);
  const determineComponent = (name) => {
    return defineAsyncComponent(() => import(`../Fields/${pascalCase(name)}SetupField.vue`));
  };
  const determineComponents = () => {
    components.value = {};
    currentFields.value.forEach((section) => {
      components.value[section.name] = determineComponent(section.name);
    });
  };
  onMounted(() => determineComponents());
</script>

<template>
  <div class="space-y-6">
    <div
      v-for="field in currentFields"
      :key="`setup-field-${field.name}`">
      <component :is="components[field.name]" />
    </div>
  </div>
</template>
